import { getDurationTimeUtil } from '@gymaholic/packages'
import ButtonPrimary from 'components/ButtonPrimary'
import ContentBox from 'components/ContentBox'
import TextBodySmall from 'components/TextBodySmall'
import TextTitle from 'components/TextTitle'
import { View } from 'components/View'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import hasSuccessStatusReduxUtil from 'modules/redux/utils/has-success-status'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'
import getDurationWorkoutUtil from 'modules/training/models/workout/utils/get-duration'
import loadByRecommendedIdWorkoutAction from 'modules/workout/redux/actions/load-recommended-by-id'
import { getByIdWorkoutSelector } from 'modules/workout/redux/selectors'
import React from 'react'
import Link from 'components/Link'
import WorkoutMediaImage from 'containers/WorkoutMediaImage'
import { IMAGE_ASPECT_RATIO_ID } from 'components/Image/constants'
import Hoverable from 'components/Hoverable'
import getWidthCardUtil from 'components/Card/utils/get-width'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { usePreviousHookUtil } from 'modules/component/utils/hooks/usePrevious.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import { defineMessages } from 'react-intl'
import TrendingIconOverlay from 'components/TrendingIconOverlay/index.js'
import isTrendingModelUtil from 'models/utils/is-trending/index.js'
import getPathnameWorkoutUtil from 'modules/workout/redux/utils/get-pathname/index.js'
import { isMobileScreenViewportSelect } from 'modules/viewport/selectors/index.js'
import getNamePlanUtil from 'modules/training/models/plan/utils/get-name/index.js'

const ANALYTIC_EVENT = {
  VIEW_WORKOUT: 'View Workout',
  VIEW_WORKOUT_IMAGE: 'View Workout Image'
}

const messages = defineMessages({
  viewWorkout: {
    id: 'WorkoutCard.viewWorkout',
    defaultMessage: 'View Workout'
  }
})

/**
 * @param isClickable
 * @param isFixedWidth
 * @param shouldLoad
 * @param parent
 * @param id
 * @param shouldShowViewButton
 * @param imageWidth
 * @param titleHeight
 * @returns {Element}
 * @constructor
 */
export default function WorkoutCard ({
  isClickable,
  shouldLoad,
  parent,
  id,
  shouldShowViewButton = true,
  isFixedWidth,
  titleHeight,
  imageWidth
}) {
  const value = useSelector(getByIdWorkoutSelector(id))
  const isMobileScreen = useSelector(isMobileScreenViewportSelect)
  const intl = useIntl()
  const prevId = usePreviousHookUtil(id)
  const isDifferentId = prevId && id !== prevId
  const dispatch = useDispatch()

  const loadOnMount = () => {
    if (!id) {
      return
    }

    if (!shouldLoad) {
      return
    }

    dispatch(
      loadByRecommendedIdWorkoutAction({
        id
      })
    )
  }

  const handleMount = () => {
    loadOnMount()
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  React.useEffect(() => {
    if (!shouldLoad) {
      return
    }

    dispatch(
      loadByRecommendedIdWorkoutAction({
        id
      })
    )
  }, [isDifferentId])

  const handleClickViewWorkout = () => {
    logEventAnalyticsUtil(
      parent
        ? getActionStrReduxUtil(parent, ANALYTIC_EVENT.VIEW_WORKOUT)
        : ANALYTIC_EVENT.VIEW_WORKOUT
    )
  }

  const handleClickImage = () => {
    logEventAnalyticsUtil(
      parent
        ? getActionStrReduxUtil(parent, ANALYTIC_EVENT.VIEW_WORKOUT_IMAGE)
        : ANALYTIC_EVENT.VIEW_WORKOUT_IMAGE
    )
  }

  const renderDuration = () => {
    const duration = getDurationWorkoutUtil(value)
    return (
      <View>
        <TextBodySmall>
          {
            duration && duration > 60
              ? getDurationTimeUtil(duration)
              : '-'
          }
        </TextBodySmall>
      </View>
    )
  }

  const renderImage = () => {
    const id = getIdReduxUtil(value)
    const width = imageWidth || getWidthCardUtil({
      isMobileScreen,
      isFixedWidth
    })
    const isTrending = !!isTrendingModelUtil(value)

    const elem = (
      <View
        style={{
          width,
          position: 'relative'
        }}
      >
        {!!isTrending && <TrendingIconOverlay />}

        <WorkoutMediaImage
          id={id}
          aspectRatio={IMAGE_ASPECT_RATIO_ID.WIDE}
        />
      </View>
      // style={{
      //   height: 'auto',
      //   width: isSmallScreen ? '100%' : '500px',
      //   maxWidth: '100%'
      // }}
    )

    if (!isClickable) {
      return elem
    }

    return (
      <Link
        to={getPathnameWorkoutUtil(value)}
        onClick={handleClickImage}
      >
        {elem}
      </Link>
    )
  }

  const renderViewButton = () => {
    if (!isClickable) {
      return
    }

    return (
      <View
        style={{
          flexDirection: View.DIRECTION.ROW
        }}
      >
        <ButtonPrimary
          url={getPathnameWorkoutUtil(value)}
          onClick={handleClickViewWorkout}

        >
          {
            formatMessageIntlUtil(
              intl,
              messages.viewWorkout
            )
          }
        </ButtonPrimary>
      </View>
    )
  }

  if (!value) {
    return <></>
  }

  if (!hasSuccessStatusReduxUtil(value)) {
    return <></>
  }

  const ImageWrapper = isClickable
    ? Hoverable
    : React.Fragment

  return (
    <ContentBox
      p={0}
    >

      <View>
        <View style={{ height: titleHeight, overflow: 'hidden' }}>
          <TextTitle>
            {getNamePlanUtil(value)}
          </TextTitle>
        </View>

        <div style={{ paddingBottom: STYLES_PADDING.TINY }}>
          <View
            style={{
              flexDirection: View.DIRECTION.ROW,
              justifyContent: isClickable
                ? null
                : View.JUSTIFY.CENTER,
              width: '100%'
            }}
          >
            {renderDuration()}
          </View>
        </div>

        <div style={{ paddingBottom: STYLES_PADDING.SMALLEST }}>
          <ImageWrapper>
            {renderImage()}
          </ImageWrapper>
        </div>

        {
          shouldShowViewButton && (
            renderViewButton()
          )
        }
      </View>
    </ContentBox>
  )
}
